import { matchIsValidTel } from "mui-tel-input";
import * as Yup from "yup";
import {
  FIELD_REQUIRED,
  TELEPHONE_INVALIDE,
} from "../../../../common/constants/validationErrors";

export const createAccountValidationSchema = Yup.object().shape({
  raisonSociale: Yup.string().required(FIELD_REQUIRED),
  acceptPolicy: Yup.boolean().required(FIELD_REQUIRED).oneOf([true], 'Must accept terms'),
  payId: Yup.number().required(FIELD_REQUIRED).transform((value, originalValue) => {
    return originalValue === '' ? undefined : value;
  }),
  email: Yup.string()
    .required(FIELD_REQUIRED)
    .email("registration.mailValidation"),
  telephone: Yup.string()
    .required(FIELD_REQUIRED)
    .test("phone-format", TELEPHONE_INVALIDE, (value) =>
      !value || matchIsValidTel(value)
    ),
});
